import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { FileUpload, FormButtons, FormRow } from '../controls';

const defaultLinks = {
  instagram: '',
  twitter: '',
  facebook: '',
  web: '',
};

function buildDefaultValues(sponsor) {
  return {
    sponsorName: sponsor.sponsorName || '',
    sponsorDescription: sponsor.sponsorDescription || '',
    links: sponsor.links || defaultLinks,
  };
}

export const SponsorForm = ({
  sponsor,
  onFileUpload,
  onFileDelete,
  handleSave,
  handleRemove,
}) => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: buildDefaultValues(sponsor),
    mode: 'onSubmit',
  });

  useEffect(() => {
    reset(buildDefaultValues(sponsor));
  }, [sponsor, reset]);

  const fileList = [];

  if (sponsor.photoURL) {
    fileList.push({
      uid: '-1',
      name: sponsor.sponsorPhoto,
      url: sponsor.photoURL,
      status: 'done',
    });
  }

  return (
    <form onSubmit={handleSubmit(handleSave)}>
      <div className="flex">
        <div className="flex w-3/4 items-center p-4">
          <FormRow label="Sponsor Name" error={errors.sponsorName?.message}>
            <input
              type="text"
              placeholder="Name"
              {...register('sponsorName', {
                required: 'Sponsor name is required',
              })}
            />
          </FormRow>
        </div>
        <div className="w-1/4 p-4">
          <FormRow>
            <div className="w-full">
              <FileUpload
                fileList={fileList}
                onFileUpload={onFileUpload}
                onFileDelete={onFileDelete}
              />
            </div>
          </FormRow>
        </div>
      </div>
      <FormRow label="Description">
        <textarea
          placeholder="Sponsor Description..."
          {...register('sponsorDescription')}
        />
      </FormRow>
      <FormRow label={<FontAwesomeIcon icon={['fas', 'globe']} />}>
        <input type="text" placeholder="Website" {...register('links.web')} />
      </FormRow>
      <FormRow label={<FontAwesomeIcon icon={['fab', 'facebook']} />}>
        <input
          type="text"
          placeholder="Facebook"
          {...register('links.facebook')}
        />
      </FormRow>
      <FormRow label={<FontAwesomeIcon icon={['fab', 'twitter']} />}>
        <input
          type="text"
          placeholder="Twitter"
          {...register('links.twitter')}
        />
      </FormRow>
      <FormRow label={<FontAwesomeIcon icon={['fab', 'instagram']} />}>
        <input
          type="text"
          placeholder="Instagram"
          {...register('links.instagram')}
        />
      </FormRow>
      <FormButtons
        showDelete={sponsor.sponsorId}
        label="Sponsor"
        onDelete={handleRemove}
      />
    </form>
  );
};
